import { useMemo } from "react";
import moment from "moment";

const useProductData = (fetchData) => {
  const data = fetchData;

  const formattedData = useMemo(() => {
    const rows = [];

    if (data && Array.isArray(data)) {
      data.forEach((order, index) => {
        // Extract Customer details
        const customer = order.Customer || {};
        const orderBorrows = order.order_borrows || [];

        // Format each product within the order_borrows
        const formattedOrderBorrows = orderBorrows.map((borrow) => {
          const product = borrow.Product || {}; // Extract product details from each borrow

          return {
            id: borrow.id || "",
            lenting_amount: borrow.lenting_amount || 0,
            price: borrow.price || 0,
            total_price: borrow.total_price || 0,
            payment_channel: borrow.payment_channel || "",
            notes_order: borrow.notes || "",
            penalty: borrow.penalty || 0,
            // slip_pictures: borrow.slip_pictures || "",
            slip_pictures: Array.isArray(order.picture_slips)
              ? order.picture_slips.map((picture) => ({
                  id: picture.id,
                  picture: picture.pic
                    .split("http")
                    .filter(Boolean)
                    .map((url) => `http${url.trim()}`),
                }))
              : [], // Ensure pictures is always an array
            // price: borrow.price, // Sum of lenting_amount for all borrowed products
            status: borrow.status || "",
            return_date: borrow.return_date
              ? moment(borrow.return_date).format(
                  "DD/MM/YYYY\n เวลา HH:mm:ss น."
                )
              : "",
            product_price: product.price || "",
            total_amount: product.total_amount || "",
            remaining_amount: product.remaining_amount || "",
            // total_price: product.total_price || "",
            product_id: product.product_id || "",
            product_name: product.product_name || "",
            product_code: product.product_code || "",
            product_code_com: product.product_code_com || "",
            category_id: product.category_id || "",
            detail: product.detail || "",
            blemishes: product.blemishes || "",
            size: product.size || "",
            notes: product.notes || "",
            product_code_com: product.product_code_com || "",
            pictures: Array.isArray(product.Pictures)
              ? product.Pictures.map((picture) => ({
                  id: picture.id,
                  picture: picture.pic
                    .split("http")
                    .filter(Boolean)
                    .map((url) => `http${url.trim()}`),
                }))
              : [], // Ensure pictures is always an array
          };
        });

        // Calculate total price, lenting_amount and return_date for the order
        const total_price = orderBorrows.reduce(
          (sum, borrow) => sum + parseFloat(borrow.total_price || 0),
          0
        );
        const lenting_amount = orderBorrows.reduce(
          (sum, borrow) => sum + parseFloat(borrow.lenting_amount || 0),
          0
        );
        const return_date =
          orderBorrows.length > 0
            ? moment(orderBorrows[0].return_date).format(
                "DD/MM/YYYY\n เวลา HH:mm:ss น."
              )
            : "";

        const length_type = formattedOrderBorrows.length;

        // Map data to the desired format
        const row = {
          id: order.id || index,
          order_code: order.order_code || "",
          qrcode: order.qrcode || "",
          company_id: order.company_id || "",
          order_status: order.order_status || "",
          created_date: order.created_at
            ? moment(order.created_at).format("DD/MM/YYYY\n เวลา HH:mm:ss น.")
            : "",
          updated_date: order.updated_at
            ? moment(order.updated_at).format("DD/MM/YYYY\n เวลา HH:mm:ss น.")
            : "",
          prefix: customer.prefix || "",
          customer_name: customer.name || "",
          idcard: customer.idcard || "",
          phonenumber: customer.phonenumber || "",
          address: customer.address || "",
          nationality: customer.nationality || "",
          customer_image: customer.image || "",
          picture:
            formattedOrderBorrows.length > 0 &&
            formattedOrderBorrows[0].pictures.length > 0
              ? formattedOrderBorrows[0].pictures
              : [], // กรณีที่ไม่มีข้อมูล
          order_borrows: formattedOrderBorrows, // Include formatted products
          total_price: total_price, // Sum of total_price for all borrowed products
          lenting_amount: lenting_amount, // Sum of lenting_amount for all borrowed products
          return_date: return_date, // Use return_date from the first borrowed product (if available)
          length_type: length_type,
        };

        rows.push(row);
      });

      // console.log("Formatted Rows:", rows);
    }

    return rows;
  }, [data]);

  return formattedData;
};

export default useProductData;
